// ----------------------------------------------------------------------

export default function Autocomplete(theme) {
  return {
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          boxShadow: theme.customShadows.dropdown,
          border: '1px solid black',
          margin: theme.spacing(1, 0, 0, 0),
        },
        listbox: {
          padding: theme.spacing(1),
          '& .MuiAutocomplete-option': {
            padding: theme.spacing(1),
            margin: theme.spacing(1, 1, 1, 0),
          },
        },
      },
    },
  };
}
